import {EnvTypes, withSystem} from '@packages/systems/wfdl';
import {functionOf, TNumber, TText} from '@packages/systems/wfdl-ast';

export const numberToText: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: functionOf(withSystem({isBindable: true}, TNumber), TText),
    implicit: 'prefilledArgs',
    exported: 'hidden',
  },
  value: String,
};
